import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams,
  Outlet,
  useNavigate,
} from "react-router-dom";
import {
  Wrapper,
  Sidebar,
  ReportArea,
  ReportSlot,
  ReportLink,
  Output,
  Links,
} from "./styled.js";
import { TitleContainer } from "../styles.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { Subtitle } from "../../main-styles.js";

const reports = [
  { divider: true, name: "Tickets" },
  { id: "/tickets", name: "Desempenho de Tickets" },
  { id: "/temporal-trends", name: "Análise Temporal" },
  { divider: true, name: "CSAT" },
  { id: "/csat", name: "Relatório de CSAT" },
  { id: "/csat/detalhes", name: "Low CSAT" },
  { divider: true, name: "Agentes" },
  { id: "/agents/performance", name: "Performance de Agentes" },
  { divider: true, name: "Grupos" },
  { id: "/groups/performance", name: "Tickets por Grupo" },
  { id: "/groups/tickets", name: "Desempenho por Grupo" },
  // { id: "5", name: "Problemas Recorrentes" },
  // { id: "6", name: "SLA" },
  // { id: "7", name: "Uso por Tenant" },
  // { id: "8", name: "Feedbacks Negativos" },
];

const App = () => {
  const navigate = useNavigate();

  function goto(path) {
    navigate(path);
  }

  return (
    <Wrapper>
      {/* Sidebar com a lista de relatórios */}
      <Sidebar>
        <TitleContainer bottom={true}>Relatórios</TitleContainer>
        <Links>
          {reports.map((report) => {
            if (report.divider) {
              return (
                <Subtitle
                  style={{
                    color: "#666",
                    fontSize: "1.01rem",
                    fontWeight: "bold",
                  }}
                >
                  {report.name}
                </Subtitle>
              );
            }

            return (
              <ReportLink
                key={report.id}
                onClick={() => goto(`/agents/reports${report.id}`)}
              >
                <FontAwesomeIcon icon={faChevronRight} />
                {report.name}
              </ReportLink>
            );
          })}
        </Links>
      </Sidebar>

      {/* Área de Relatórios */}
      <ReportArea>
        <Outlet />
      </ReportArea>
    </Wrapper>
  );
};

export default App;
